// extracted by mini-css-extract-plugin
export default {"base":"styles-module--base--3guVd","submitBtn":"styles-module--submitBtn--My-6b","status":"styles-module--status--PCxCv","fadeIn":"styles-module--fadeIn--MAqKX"};